import React, { useState, useEffect } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import MobileHeader from "../components/MobileHeader";
import FloatingActionButton from "../components/home/FloatingActionButton";
import PopUpModal from "../components/PopUpModal"; // Add this import

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: ""
  });

  const [formSubmitted, setFormSubmitted] = useState(false);
  const [showModal, setShowModal] = useState(false); // Add state for popup modal

  // Scroll to top when the component is mounted
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Show popup modal after 8 seconds (like Home page)
  useEffect(() => {
    const timer = setTimeout(() => setShowModal(true), 8000);
    return () => clearTimeout(timer);
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Here you would typically send the form data to your backend
    // For now, we'll just set formSubmitted to true
    setFormSubmitted(true);
    
    // Reset form after 3 seconds
    setTimeout(() => {
      setFormSubmitted(false);
      setFormData({
        name: "",
        email: "",
        phone: "",
        subject: "",
        message: ""
      });
    }, 3000);
  };

  return (
    <>
      <div className="d-none d-lg-block">
        <Header />
      </div>
      <MobileHeader />

      {/* Simplified Hero Section */}
      <div className="py-3 py-md-5 bg-light">
        <div className="container text-center">
          <h1 className="fs-2 fs-md-4 fw-bold mb-2 mb-md-3">Contact Us</h1>
        </div>
      </div>

      <div className="container py-3 py-md-5">
        <div className="row g-3 g-lg-4">
          {/* Contact Information */}
          <div className="col-lg-4 mb-3 mb-lg-0">
            <div className="card shadow-sm border-0 h-100">
              <div className="card-body p-3 p-md-4">
                <h3 className="card-title mb-3 fs-4">Get In Touch</h3>
                
                <div className="d-flex align-items-start mb-3">
                  <div className="me-2 me-md-3 bg-light rounded-circle p-2 p-md-3 flex-shrink-0" style={{ color: '#FFA500' }}>
                    <i className="fas fa-map-marker-alt fa-fw"></i>
                  </div>
                  <div className="text-start">
                    <h5 className="mb-0 fs-6 fs-md-5">Visit Us</h5>
                    <p className="mb-0 text-muted small">1 Street, Mumbai, 400000</p>
                  </div>
                </div>
                
                <div className="d-flex align-items-start mb-3">
                  <div className="me-2 me-md-3 bg-light rounded-circle p-2 p-md-3 flex-shrink-0" style={{ color: '#FFA500' }}>
                    <i className="fas fa-phone-alt fa-fw"></i>
                  </div>
                  <div className="text-start">
                    <h5 className="mb-0 fs-6 fs-md-5">Call Us</h5>
                    <p className="mb-0 text-muted small">+91 92204 24206</p>
                  </div>
                </div>
                
                <div className="d-flex align-items-start mb-3">
                  <div className="me-2 me-md-3 bg-light rounded-circle p-2 p-md-3 flex-shrink-0" style={{ color: '#FFA500' }}>
                    <i className="fas fa-envelope fa-fw"></i>
                  </div>
                  <div className="text-start">
                    <h5 className="mb-0 fs-6 fs-md-5">Email Us</h5>
                    <p className="mb-0 text-muted small">infoswayourway@gmail.com </p>
                  </div>
                </div>
                
                <div className="d-flex align-items-start">
                  <div className="me-2 me-md-3 bg-light rounded-circle p-2 p-md-3 flex-shrink-0" style={{ color: '#FFA500' }}>
                    <i className="fas fa-clock fa-fw"></i>
                  </div>
                  <div className="text-start">
                    <h5 className="mb-0 fs-6 fs-md-5">Working Hours</h5>
                    <p className="mb-0 text-muted small">Mon - Sat: 9 AM - 6 PM</p>
                  </div>
                </div>

                {/* Social Media Section */}
                <div className="mt-3 mt-md-4 text-center">
                  <h3 className="mb-2 mb-md-3 fs-4">Connect With Us</h3>
                  <div className="d-flex justify-content-center gap-2 gap-md-4">
                    <a href="#" className="text-decoration-none">
                      <div className="bg-light rounded-circle p-2 p-md-3" style={{ color: '#FFA500' }}>
                        <i className="fab fa-facebook-f"></i>
                      </div>
                    </a>
                    <a href="#" className="text-decoration-none">
                      <div className="bg-light rounded-circle p-2 p-md-3" style={{ color: '#FFA500' }}>
                        <i className="fab fa-instagram"></i>
                      </div>
                    </a>
                    <a href="#" className="text-decoration-none">
                      <div className="bg-light rounded-circle p-2 p-md-3" style={{ color: '#FFA500' }}>
                        <i className="fab fa-twitter"></i>
                      </div>
                    </a>
                    <a href="#" className="text-decoration-none">
                      <div className="bg-light rounded-circle p-2 p-md-3" style={{ color: '#FFA500' }}>
                        <i className="fab fa-whatsapp"></i>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          {/* Contact Form */}
          <div className="col-lg-8">
            <div className="card shadow-sm border-0 h-100">
              <div className="card-body p-3 p-md-4">
                <h3 className="card-title mb-3 fs-4">Send Us a Message</h3>
                
                {formSubmitted ? (
                  <div className="alert alert-success p-2 p-md-3">
                    <h5 className="mb-0 fs-6 fs-md-5">Thank you for contacting us!</h5>
                    <p className="mb-0 small">We have received your message and will get back to you soon.</p>
                  </div>
                ) : (
                  <form onSubmit={handleSubmit} className="row g-2 g-md-3">
                    <div className="col-md-6 mb-2 mb-md-3">
                      <label htmlFor="name" className="form-label small">Your Name</label>
                      <input
                        type="text"
                        className="form-control form-control-sm form-control-md-lg"
                        id="name"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="col-md-6 mb-2 mb-md-3">
                      <label htmlFor="email" className="form-label small">Email Address</label>
                      <input
                        type="email"
                        className="form-control form-control-sm form-control-md-lg"
                        id="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    
                    <div className="col-md-6 mb-2 mb-md-3">
                      <label htmlFor="phone" className="form-label small">Phone Number</label>
                      <input
                        type="tel"
                        className="form-control form-control-sm form-control-md-lg"
                        id="phone"
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="col-md-6 mb-2 mb-md-3">
                      <label htmlFor="subject" className="form-label small">Subject</label>
                      <input
                        type="text"
                        className="form-control form-control-sm form-control-md-lg"
                        id="subject"
                        name="subject"
                        value={formData.subject}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    
                    <div className="mb-2 mb-md-3">
                      <label htmlFor="message" className="form-label small">Message</label>
                      <textarea
                        className="form-control form-control-sm form-control-md-lg"
                        id="message"
                        name="message"
                        rows="3"
                        value={formData.message}
                        onChange={handleChange}
                        required
                      ></textarea>
                    </div>
                    
                    <div className="text-end">
                      <button 
                        type="submit" 
                        className="btn px-3 px-md-4 py-1 py-md-2 rounded-pill"
                        style={{ backgroundColor: '#FFA500', borderColor: '#FFA500', color: '#fff' }}
                      >
                        <i className="fas fa-paper-plane me-1 me-md-2"></i>
                        <span className="small">Send Message</span>
                      </button>
                    </div>
                  </form>
                )}
              </div>
            </div>
          </div>
        </div>
        
        {/* Map Section */}
        <div className="row mt-3 mt-md-4">
          <div className="col-12">
            <div className="card shadow-sm border-0">
              <div className="card-body p-0">
                <iframe 
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d241317.11609823277!2d72.88118615!3d19.08205765!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7c6306644edc1%3A0x5da4ed8f8d648c69!2sMumbai%2C%20Maharashtra!5e0!3m2!1sen!2sin!4v1654789958159!5m2!1sen!2sin" 
                  width="100%" 
                  height="250"
                  className="d-md-none"
                  style={{ border: 0 }} 
                  allowFullScreen="" 
                  loading="lazy" 
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Sway Your Way Tours Location"
                ></iframe>
                <iframe 
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d241317.11609823277!2d72.88118615!3d19.08205765!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7c6306644edc1%3A0x5da4ed8f8d648c69!2sMumbai%2C%20Maharashtra!5e0!3m2!1sen!2sin!4v1654789958159!5m2!1sen!2sin" 
                  width="100%" 
                  height="450"
                  className="d-none d-md-block"
                  style={{ border: 0 }} 
                  allowFullScreen="" 
                  loading="lazy" 
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Sway Your Way Tours Location"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
      <FloatingActionButton />
      <Footer />
      <PopUpModal isOpen={showModal} onClose={() => setShowModal(false)} />
    </>
  );
};

export default Contact;
